import Vue from 'vue'
import api from '@/lib/hippo'
import Province from '@/models/province';

function initialState() {
    return {
        provinces: {}
    };
}

const state = initialState;

const getters = {
    getProvinces: (state) => state.provinces
};

const actions = {
    
    fetchProvinces({ commit, state, rootGetters }) {
        return new Promise((resolve, reject) => {
           
        
        api.getProvinces().then((response) => {
            commit('addProvinces', Province.from(response.data));
            resolve(true);
        }).catch((err) => reject(err));
            
            // else {
            //     reject(new Error((!rootGetters.apiToken) ? 'You are no longer logged in.' : 'Missing required parameter.'));
            // }
        });
    },


    resetProvincesState({ commit }) {
        commit('resetState');
    }
}

const mutations = {
    addProvinces: (state, provinces) => {
        Vue.set(state, 'provinces', provinces);
    },

    resetState(state) {
        const s = initialState();
        Object.keys(s).forEach(key => {
            Vue.set(state, key, s[key]);
        });
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}